<template>
  <div class="container-fluid">
    <HeaderBar @onFilterChange="onFilterChange"/>
    <div class="row">
      <div data-aos="fade-up" class="col-lg-12">
        <div class="shadow-block graphs-block">
          <div class="block-header">
            <h5 v-if="chartItem" class="block-heading">{{chartItem.title}}</h5>
          </div>
          <dynamic-chart ref="lineChart" :chartOptions="chartItem" :needTitle="needTitle"/>
        </div>
      </div>
    </div>
    <div class="row">
      <div data-aos="fade-up" class="col-lg-12">
        <div class="shadow-block graphs-block">
          <div class="block-header">
            <h2 v-if="chartItem!=null" >Statistics</h2>
          </div>
          <StatisticsHeader @onStaticFiltersChange="onStaticFiltersChange"/>
          <data-widget v-if="widgetData" :widgetData="widgetData"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import DynamicChart from '../charts/DynamicChart';
  import DataWidget from '../charts/DataWidget';
  import HeaderBar from '@/components/layout/HeaderBar';
  import StatisticsHeader from '@/components/layout/StatisticsHeader';

  export default {
    name: 'DashboardPage',
    data() {
      return {
        searchKey: '',
        updateArgs: [true, true, {duration: 1000}],
        currentIndex: 0,
        needTitle: true,
        chartItem: {
          type: 'Spline',
          plotOptions: {
            pie: {
              innerSize: ''
            }
          },
          title: 'Sample Data',
          subtitle:'<b>This is sample data. Please select Farms and Fields to build the actual data</b>',
          categories: ['2019-07-01', '2019-08-01',
            '2019-09-01', '2019-10-01',
            '2019-11-01', '2019-12-01',
            '2020-01-01', '2020-02-01',
            '2020-03-01', '2020-04-01',
            '2020-05-01', '2020-06-01'],
          yAxis: {
            title: {
              text: ''
            }
          },
          series: [{
            showInLegend: true,
            columnTitle: 'Sample',
            data: [0.34, 0.45, 0.56, 0.14, 0.14, 0.19,
              0.34, 0.33, 0.32, 0.65, 0.41, 0.50],
            columnColor: 'blue'
          }]
        },
        widgetData: null
      };
    },
    created() {
      const params = {};
      this.onStaticFiltersChange(params);
    },
    methods: {
      onFilterChange(params) {
        if (params.fieldUid || 'TOP' === params.farmUid || 'LEAST' === params.farmUid || 'TOP' === params.farmUidTwo || 'LEAST' === params.farmUidTwo) {
          this.$loading.show();
          this.axios.post('monterre/getFieldsData', params)
              .then(response => {
                this.$loading.hide();
                if (response.data.data && response.data.data) {
                  this.needTitle = false;
                  this.chartItem = response.data.data;
                }
              })
              .catch(error => {
                this.$loading.hide();
                if (error.response && error.response.data.status === 400) {
                  this.$toastr.error(error.response.data.message);
                }
              });
        }
      },
      onStaticFiltersChange(params) {
        this.$loading.show();
        this.axios.post('monterre/getWidgetData', params)
            .then(response => {
              this.$loading.hide();
              if (response.data.data && response.data.data) {
                this.widgetData = response.data.data;
              }
            })
            .catch(error => {
              this.$loading.hide();
              if (error.response && error.response.data.status === 400) {
                this.$toastr.error(error.response.data.message);
              }
            });
      },
    },
    components: {
      DynamicChart,
      DataWidget,
      HeaderBar,
      StatisticsHeader
    }
  };
</script>

<style scoped>

</style>